import React, { useState } from "react";
import Box from "@mui/material/Box";
import NodeTag from "./last-values/NodeTag";
import Grid from "@mui/material/Grid2";
import LastValuesDataGrid from "./last-values/LastValuesDataGrid";
import { Typography, Paper, Alert, Stack } from "@mui/material";
import ActiveAlarmsDataGrid from "./last-values/ActiveAlarmsDataGrid";
import { useTranslation } from "react-i18next";
import SummaryObjectDetails from "./last-values/SummaryObjectDetails";
export default function Summary() {
  const { t } = useTranslation();
  const [alarmCounts, setAlarmCounts] = useState({
    warnings: 0,
    alerts: 0,
  });

  const handleCountsChange = (counts) => {
    setAlarmCounts(counts);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 12 }}>
          <NodeTag />
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }} sx={{ mt: 2 }}>
          <Paper elevation={3} sx={{ p: 2, overflow: "hidden" }}>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems="center"
              justifyContent="center"
              marginBottom={2}
            >
              <Typography
                variant="h2"
                align="center"
                sx={{
                  mb: { xs: 1, sm: 2 },
                  fontSize: { xs: "1.75rem", sm: "2rem" },
                }}
              >
                {t("summary.activeAlarms")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: 2,
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: 0,
                }}
              >
                <Alert
                  severity="error"
                  sx={{
                    flex: "1 1 140px",
                    minWidth: 0,
                    maxWidth: { xs: "100%", sm: "auto" },
                  }}
                >
                  {alarmCounts.alerts} {t("summary.error")}
                </Alert>
                <Alert
                  severity="warning"
                  sx={{
                    flex: "1 1 140px",
                    minWidth: 0,
                    maxWidth: { xs: "100%", sm: "auto" },
                  }}
                >
                  {alarmCounts.warnings} {t("summary.warning")}
                </Alert>
              </Box>
            </Stack>
            <ActiveAlarmsDataGrid onCountsChange={handleCountsChange} />
          </Paper>

          <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
            <LastValuesDataGrid />
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, lg: 8 }} sx={{ mt: 2 }}>
          <SummaryObjectDetails />
        </Grid>
      </Grid>
    </Box>
  );
}
